module.exports = __webpack_public_path__ + "static/img/box.39131a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/box.png
// module id = omNA
// module chunks = 128